import{__rest as e}from"../../node_modules/tslib/tslib.es6.js";import t from"react";import{StyledOverlay as r}from"./Overlay.styled.js";const s=s=>{s=e(s,[]);return t.createElement(r,Object.assign({},s))};export{s as default};
